import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import MainApp from './components/MainApp';
import SelectDashboard from './components/SelectDashboard';
import SetupPage from './components/SetupPage';
import ClaudeDashboard from './components/ClaudeDashboard';
import GeminiDashboard from './components/GeminiDashboard';
import OpenAIDashboard from './components/OpenAIDashboard';
import GrokDashboard from './components/GrokDashboard';
import GeminiPromptGenerator from './components/GeminiPromptGenerator';
import LogScreen from './components/LogScreen';
import MetricsScreen from './components/MetricsScreen';

const AppRouter = () => {
  return (
    <BrowserRouter basename="/dev">
      <Switch>
        {/* Main setup landing page */}
        <Route
          path="/main_app"
          component={MainApp}
        />

        {/* Dashboard selection page */}
        <Route
          path="/select_dash"
          component={SelectDashboard}
        />

        {/* Setup pages for each provider */}
        <Route
          path="/claude_setup"
          render={(props) => <SetupPage provider="claude" {...props} />}
        />
        <Route
          path="/gemini_setup"
          render={(props) => <SetupPage provider="gemini" {...props} />}
        />
        <Route
          path="/openai_setup"
          render={(props) => <SetupPage provider="openai" {...props} />}
        />
        <Route
          path="/grok_setup"
          render={(props) => <SetupPage provider="grok" {...props} />}
        />

        {/* Dashboard pages */}
        <Route
          path="/claude"
          component={ClaudeDashboard}
        />
        <Route
          path="/gemini"
          component={GeminiDashboard}
        />
        <Route
          path="/gemini_generator"
          component={GeminiPromptGenerator}
        />
        <Route
          path="/openai"
          component={OpenAIDashboard}
        />
        <Route
          path="/grok"
          component={GrokDashboard}
        />

        <Route
          path="/logs"
          component={LogScreen}
        />

        <Route
          path="/metrics"
          component={MetricsScreen}
        />

        {/* Default routes */}
        <Route exact path="/" render={() => <Redirect to="/gemini_generator" />} />
        <Redirect to="/gemini_generator" />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRouter;
